<template>
  <div id="base-raw-data">
    <div v-if="rawDatas.length" xs12>{{ rawDatas[0].rawDataText }}</div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'base-raw-data',
  data() {
    return {}
  },
  computed: {
    productId() {
      return window.atob(this.$route.params.productId)
      // return this.$store.state.Product.searchProductId
    },
    rawDatas() {
      return _.shuffle(this.$store.state.RawData.data)
    }
  },
  created() {
    this.$store.dispatch('RawData/fetch', this.productId)
  }
}
</script>

<style lang="scss" scoped></style>
